import { defineStore } from "pinia";
import { fetchCurrentUser } from "@/services/authService";
import { subscribeToMercure, unsubscribeFromMercure } from '@/services/mercure';
import { useMessaging } from "@/composables/useMessaging";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("access_token") || "",
    email: localStorage.getItem("email") || "",
    sub: localStorage.getItem("user_sub") || "",
    user: null as null | {
      roles: string[];
      firstName: string;
      lastName: string;
      email: string;
      [key: string]: any;
    },
    // mercureUnsubscribe: null as null | (() => void),
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => state.user?.roles?.includes("ROLE_ADMIN") || false,
    fullName: (state) => state.user ? `${state.user.firstName} ${state.user.lastName}` : '',
  },

  actions: {
    setToken(token: string, sub?: string) {
      this.token = token;
      this.sub = sub ?? '';
      localStorage.setItem('access_token', token);
      if (sub) {
        localStorage.setItem('user_sub', sub);
      }
    },

    setUser(user: any) {
      this.user = user;
    },

    setEmail(email: string) {
      this.email = email;
      localStorage.setItem('email', email);
    },

    logout() {
      this.token = '';
      this.user = null;
      this.email = '';
      this.sub = '';
      localStorage.removeItem('access_token');
      localStorage.removeItem('email');
      localStorage.removeItem('user_sub');

      // if (this.mercureUnsubscribe) {
      //   try {
      //     this.mercureUnsubscribe();
      //   } catch (e) { 
      //     console.warn("Error unsubscribing from Mercure:", e);
      //   }
      //   this.mercureUnsubscribe = null;
      // }

      try {
        unsubscribeFromMercure();
      } catch (e) {
        console.warn("Error unsubscribing from Mercure:", e);
      }
    },

    clearToken() {
      this.token = '';
      localStorage.removeItem('access_token');
    },

    async fetchUserIfNeeded() {
      
      if (this.token && !this.user) {
        //console.log("Fetching user if needed");
        try {
          const user = await fetchCurrentUser();
          await this.setUser(user);
          await useMessaging().registerHandlers(user);
          //console.log("Fetched user:", user);
        } catch (error) {
          console.error("Error fetching user:", error);
          this.logout();
        }
      }
    },

    async validateToken() {
      if (this.token) {
        return true;
      } else {
        this.logout();
        return false;
      }
    },
  },
});
